require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 319
// module chunks = 0